import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/questionAndFeedBacks/getAll', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/questionAndFeedBacks/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	contactUs: async (viewModel) => {
		return await commonApi().post('/v1/admin/questionAndFeedBacks/contactUs?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	answer: async (viewModel) => {
		return await commonApi().post('/v1/admin/questionAndFeedBacks/answer?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}